export enum LeadChannel {
  flex = 'twilio_flex',
  twilio = 'twilio',
  donor_app = 'donor_app',
  captain_app = 'captain_app',
  charity_app = 'charity_app',
}
